/** Route templates are reviewed constants. Actual path and query values stay local. */
export type PageCommitContract = {
  key: string
  source: string
  route: string
  aliases?: ReadonlyArray<string>
  phase: 'page_component_committed' | 'redirect_issued'
  terminal: string
  domain: string
}

export function matchesPageRoute(template: string, pathname: string): boolean {
  const parts = template.split('/').filter(Boolean)
  const actual = pathname.split('/').filter(Boolean)
  let index = 0
  for (const part of parts) {
    if (part.startsWith('[[...') && part.endsWith(']]')) {
      return true
    }
    if (part.startsWith('[...') && part.endsWith(']')) {
      return index < actual.length
    }
    if (actual[index] === undefined) {
      return false
    }
    if (
      !(part.startsWith('[') && part.endsWith(']')) &&
      part !== actual[index]
    ) {
      return false
    }
    index += 1
  }
  return index === actual.length
}

function segmentRank(segment: string | undefined): number {
  if (segment === undefined) {
    return 4
  }
  if (segment.startsWith('[[...')) {
    return 0
  }
  if (segment.startsWith('[...')) {
    return 1
  }
  return segment.startsWith('[') ? 2 : 3
}

/** Prefer the same specific route that the router selects for overlapping templates. */
export function comparePageRouteSpecificity(
  left: string,
  right: string
): number {
  const leftParts = left.split('/').filter(Boolean)
  const rightParts = right.split('/').filter(Boolean)
  for (
    let index = 0;
    index < Math.max(leftParts.length, rightParts.length);
    index += 1
  ) {
    const difference =
      segmentRank(rightParts[index]) - segmentRank(leftParts[index])
    if (difference !== 0) {
      return difference
    }
  }
  return 0
}
